module.exports = __webpack_public_path__ + "media/images/print-logo-ce5d3d01aa306c3e863b6855dbddacc3.jpg";